module.exports = __webpack_public_path__ + "static/media/6m_website_logo_Platinum_cmobile.dd531f75.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/home/partners_logos/6m_website_logo_Platinum_cmobile.jpg
// module id = 108
// module chunks = 0